import React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api, { API } from "@/lib/api";
import Seo from "@/components/shared/Seo";
import Btn from "@/components/shared/Btn";
import { Download, MapPin, Calendar, Clock, CheckCircle2 } from "lucide-react";

const Billet = () => {
  const { token } = useParams();
  const { data: t, isLoading, isError } = useQuery({
    queryKey: ["ticket", token],
    queryFn: async () => (await api.get(`/tickets/${token}`)).data,
    retry: false,
  });

  if (isLoading) return <div className="min-h-screen bg-f2b-black" />;
  if (isError || !t) return (
    <div className="min-h-screen bg-f2b-black flex items-center justify-center text-center px-6 pt-32">
      <div>
        <h1 className="font-display font-bold text-white text-3xl">Billet introuvable</h1>
        <p className="text-white/60 mt-3">Ce billet n'existe pas ou l'inscription n'est pas confirmée.</p>
      </div>
    </div>
  );

  const ed = t.edition || {};
  return (
    <>
      <Seo title={`Billet ${t.ticket_number} — FACADES2build`} description="Votre billet nominatif FACADES2build." />
      <section className="min-h-screen bg-f2b-black pt-32 pb-20 flex items-center">
        <div className="f2b-container max-w-lg w-full">
          <div className="bg-white overflow-hidden" data-testid="billet-card">
            <div className="bg-f2b-black text-white px-8 py-6 border-b-2 border-f2b-cyan">
              <div className="flex items-baseline gap-0.5">
                <span className="font-display text-xl font-bold">FACADES</span>
                <span className="font-display text-xl font-bold text-f2b-cyan">2</span>
                <span className="font-display text-xl font-bold">build</span>
              </div>
              <p className="f2b-kicker text-f2b-cyan mt-1">Billet nominatif</p>
            </div>

            <div className="p-8">
              <h1 className="font-display font-bold text-f2b-black text-2xl leading-tight">{ed.theme}</h1>
              <div className="flex flex-col gap-2 mt-4 text-sm text-f2b-gray">
                <span className="flex items-center gap-2"><Calendar size={16} className="text-f2b-cyan" /> {ed.date_label}</span>
                {ed.schedule && <span className="flex items-center gap-2"><Clock size={16} className="text-f2b-cyan" /> {ed.schedule}</span>}
                <span className="flex items-center gap-2"><MapPin size={16} className="text-f2b-cyan" /> {ed.venue || ed.city}</span>
              </div>

              <div className="border-t border-dashed border-f2b-filet my-6" />

              <div className="flex items-center justify-between gap-4">
                <div>
                  <p className="f2b-kicker text-f2b-gray">Participant</p>
                  <p className="font-display font-bold text-f2b-black text-xl mt-1">{t.first_name} {t.last_name}</p>
                  {t.company && <p className="text-f2b-gray text-sm">{t.company}</p>}
                  <p className="text-f2b-black font-medium mt-3" data-testid="billet-number">{t.ticket_number}</p>
                  {t.status === "Présent" && (
                    <p className="flex items-center gap-1 text-green-600 text-sm mt-2"><CheckCircle2 size={15} /> Arrivé le {new Date(t.checkin_at).toLocaleString("fr-FR")}</p>
                  )}
                </div>
                <img src={`${API}/tickets/${token}/qr.png`} alt="QR code du billet" className="w-28 h-28 border border-f2b-filet" data-testid="billet-qr" />
              </div>

              <Btn variant="cyan" href={`${API}/tickets/${token}/pdf`} className="w-full mt-8" data-testid="billet-download">
                <Download size={18} /> Télécharger mon billet (PDF)
              </Btn>
            </div>
          </div>
          <p className="text-white/40 text-xs text-center mt-6">Présentez ce QR code à l'accueil. Un billet est établi par participant.</p>
        </div>
      </section>
    </>
  );
};

export default Billet;
